import { useRef, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import D1GhgAndFuelConsumption from './D1GhgAndFuelConsumption/D1GhgAndFuelConsumption';
import D2DistanceTravelled from './D2DistanceTravelled/D2DistanceTravelled';
import D3CargoCarried from './D3CargoCarried/D3CargoCarried';
import D4TimeSpentAtSea from './D4TimeSpentAtSea/D4TimeSpentAtSea';

const DataGaps = ({ data, refetchMonitoringData, dropdownData,vesselMstId }) => {
    const [expandedPanel, setExpandedPanel] = useState('panel1');
    // const handleChange = (panel) => (_, isExpanded) => {
    //     setExpandedPanel(isExpanded ? panel : false);
    // };

    const methods = useForm({
        mode: 'onBlur',
        defaultValues: {
        },
    });

    const renderTitleWithIcon = (panel, title) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ fontSize: '20px', fontWeight: 'bold' }}>
                {expandedPanel === panel ? '−' : '+'}
            </span>
            <p className="fuel-cons">{title}</p>
        </div>
    );

    const autoSaveForD1 = useRef();
    const autoSaveForD2 = useRef();
    const autoSaveForD3 = useRef();
    const autoSaveForD4 = useRef();

    const handleChange = (panel) => async (_, isExpanded) => {
        let isSubmitSuccess = true;
        if (expandedPanel === 'panel1' && autoSaveForD1.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForD1.current.submitAndCheck();
        } else if (expandedPanel === 'panel2' && autoSaveForD2.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForD2.current.submitAndCheck();
        } else if (expandedPanel === 'panel3' && autoSaveForD3.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForD3.current.submitAndCheck();
        } else if (expandedPanel === 'panel4' && autoSaveForD4.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForD4.current.submitAndCheck();
        }
        if (!isSubmitSuccess) return;
        // clearErrors();
        setExpandedPanel(isExpanded ? panel : false);
    };

    return (
        <FormProvider {...methods}>
            <form>
                <Accordion defaultExpanded expanded={expandedPanel === 'panel1'} onChange={handleChange('panel1')} className="mt-3">
                    <AccordionSummary className="accordion-header">
                        {renderTitleWithIcon('panel1', 'D.1 Methods to be used to estimate greenhouse gas emissions and fuel consumption')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <D1GhgAndFuelConsumption ref={autoSaveForD1} vesselMstId={vesselMstId} D1GhgAndFuelConsumptionData={data?.d1GasEmissions} refetchMonitoringData={refetchMonitoringData} dropdownData={dropdownData} />
                    </AccordionDetails>
                </Accordion>

                <Accordion defaultExpanded expanded={expandedPanel === 'panel2'} onChange={handleChange('panel2')} className="mt-3">
                    <AccordionSummary className="accordion-header">
                        {renderTitleWithIcon('panel2', 'D.2 Methods to be used to treat data gaps regarding distance travelled')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <D2DistanceTravelled ref={autoSaveForD2} vesselMstId={vesselMstId} D2DistanceTravelledData={data?.d2DataGaps} refetchMonitoringData={refetchMonitoringData} />
                    </AccordionDetails>
                </Accordion>

                <Accordion defaultExpanded expanded={expandedPanel === 'panel3'} onChange={handleChange('panel3')} className="mt-3">
                    <AccordionSummary className="accordion-header">
                        {renderTitleWithIcon('panel3', 'D.3 Methods to be used to treat data gaps regarding cargo carried')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <D3CargoCarried ref={autoSaveForD3} vesselMstId={vesselMstId} D3CargoCarriedData={data?.d3DataGapForCargo} refetchMonitoringData={refetchMonitoringData} />
                    </AccordionDetails>
                </Accordion>

                <Accordion defaultExpanded expanded={expandedPanel === 'panel4'} onChange={handleChange('panel4')} className="mt-3">
                    <AccordionSummary className="accordion-header">
                        {renderTitleWithIcon('panel4', 'D.4 Methods to be used to treat data gaps regarding time spent at sea')}
                    </AccordionSummary>
                    <AccordionDetails>
                        <D4TimeSpentAtSea ref={autoSaveForD4} vesselMstId={vesselMstId}  D4TimeSpentAtSea={data?.d4DataGapForTimeAtSea} refetchMonitoringData={refetchMonitoringData} />
                    </AccordionDetails>
                </Accordion>
            </form>
        </FormProvider>
    );
}

export default DataGaps;